import React, { useContext } from 'react';
import Swal from 'sweetalert2';
import { FaCheck } from 'react-icons/fa';
import { ReportContext } from '../../ReportContext';

const ApproveProposal = ({ solutionId }) => {
  const {approveProposal} = useContext(ReportContext)
  async function handleApprove() {
    const confirmResult = await Swal.fire({
      title: 'Confirm Approval',
      text: 'Are you sure you want to approve?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, approve',
      cancelButtonText: 'Cancel',
    });

    if (confirmResult.isConfirmed) {
      const sessionKey = `approval_notes_${solutionId}`;
      const savedDraft = sessionStorage.getItem(sessionKey) || '';

      const { value: notes } = await Swal.fire({
        title: 'Approval Notes',
        input: 'textarea',
        // width: '50vw',
        confirmButtonText: 'Approve',
        inputLabel: 'Please enter your approval notes',
        inputPlaceholder: 'Type your notes here...',
        inputValue: savedDraft,
        inputAttributes: {
          'aria-label': 'Approval notes',
          // style: 'height:30vh;',
        },
        showCancelButton: true,
        didOpen: () => {
          const textarea = Swal.getInput();
          if (textarea) {
            textarea.addEventListener('input', (e) => {
              sessionStorage.setItem(sessionKey, e.target.value);
            });
          }
        },
        preConfirm: (value) => {
          if (!value || !value.trim()) {
            Swal.showValidationMessage('Approval notes cannot be empty');
          }
          return value;
        },
      });

      if (notes) {
        // Submit the approval notes here
        // console.log('Approved with notes:', notes);
        const response = await approveProposal({solution_id:solutionId,notes})
        if (response?.status === 'success'){
          sessionStorage.removeItem(sessionKey); // Clear draft
  
          await Swal.fire('Approved!', 'Your approval has been Submitted.', 'success');
  
          // if (setReload) setReload(!reload);

        }
      }
    }
  }

  return (
    <button
      className="btn btn-outline-success btn-sm"
      title="Approve"
      onClick={handleApprove}
    >
      <FaCheck />
    </button>
  );
};

export default ApproveProposal;
